<template>
  <RouterView />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'App',
  
  async created() {
    // Initialize Bluetooth module
    if (navigator.bluetooth) {
      try {
        await this.initializeBluetooth();
      } catch (error) {
        console.warn('Failed to initialize Bluetooth:', error);
      }
    }
  },
  
  methods: {
    ...mapActions('bluetooth', ['initializeBluetooth']),
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
#app {
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #374151;
  height: 100vh;
  background-color: #F9FAFB;
  overflow-y: scroll;
}

html.dark #app {
  color: #e5e7eb;
  background-color: #030712;
}
</style>
